/** Max number of listings missing a video/tour rendered inside the group. */
export const VIDEO_TOUR_GROUP_MAX_LISTINGS = 3;

/** Square thumbnail size (px) used for the space image on each video-tour row. */
export const VIDEO_TOUR_THUMBNAIL_PX = 120;
